
import AuthenticationService from "../../security/AuthenticationService";
import GlobalModals from "@/components/widgets/Modals/GlobalModals.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    GlobalModals
  }
})
export default class AppMain extends Vue {
  @Prop({ default: false })
  validUser: boolean;

  @Prop({ default: false })
  isLoggedIn: boolean;

  get key() {
    return this.$route.path;
  }
  logout() {
    AuthenticationService.logout().then(() => {});
  }
}
